import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../hooks';

import { PayslipActions } from '../actions/payslip/payslip.actions';

import type { Payslip } from '../interfaces/employee/payslip.interface';

import HrDocumentLocker from './HrDocumentLocker';

// Payslips — thin wrapper over the shared HR document locker.  The API scopes
// GET /payslips to the current user unless they hold an HR role.
const PayslipsListV3 = () => {
  const dispatch = useAppDispatch();
  const payslips: Payslip[] = useAppSelector(({ payslip_store }) => payslip_store.payslips) || [];
  const [loaded, setLoaded] = useState(payslips.length > 0);

  useEffect(() => {
    dispatch(PayslipActions.loadPayslips(() => setLoaded(true)));
  }, [dispatch]);

  return (
    <HrDocumentLocker
      title="Payslips"
      eyebrow="Human Resources"
      noun="payslip"
      records={payslips}
      loaded={loaded}
      legacyAddPath="/human-resources/payslips/add"
      legacyEditPath={(id) => `/human-resources/payslips/${id}`}
    />
  );
};

export default PayslipsListV3;
